var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStarNew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50023 0L7.95957 4.49139H12.6821L8.86149 7.26722L10.3208 11.7586L6.50023 8.98278L2.67962 11.7586L4.13896 7.26722L0.318359 4.49139H5.04089L6.50023 0Z",
    fill: "currentCollor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStarNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star_new.5ad6a4e9.svg";
export { ForwardRef as ReactComponent };